module.exports = __webpack_public_path__ + "static/media/lang-hk.b3d85c01.svg";